import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

export const moduleName = 'callTimer';

const initialState = {
  callSec: 0,
  callStartTime: null,
};

const MILLISECONDS_IN_SECOND = 1000;

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.CALL_TIMER_RESET:
      return {
        ...state,
        callSec: 0,
        callStartTime: null,
      };
    case actionTypes.CALL_TIMER_TICK:
      return {
        ...state,
        callSec: Math.round((new Date().getTime() - state.callStartTime.getTime()) / MILLISECONDS_IN_SECOND),
      };
    case actionTypes.CALL_TIMER_TIMESTAMP:
      return {
        ...state,
        callStartTime: new Date(),
      };
    default:
      return {
        ...state,
      };
  }
};

const stateSelector = (state) => state[moduleName];

export const selectCallSec = createSelector(
  stateSelector,
  (callTimer) => callTimer.callSec,
);

export const selectCallStartTime = createSelector(
  stateSelector,
  (callTimer) => callTimer.callStartTime,
);



// WEBPACK FOOTER //
// ./reducers/callTimer.js